export default __webpack_public_path__ + "static/media/targa_europe_2020.57727b21.webp";